import { RefreshCw } from 'lucide-react';
import { useOfflineDataPrep } from '@/hooks/useOfflineDataPrep';
import { Progress } from '@/components/ui/progress';

export function SyncStatusBanner() {
  const { isPrepping, progress } = useOfflineDataPrep();

  if (!isPrepping) return null;

  return (
    <div className="fixed top-16 left-0 right-0 z-40 bg-primary/10 border-b border-primary/20 px-4 py-3">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center gap-3">
          <RefreshCw className="h-4 w-4 text-primary animate-spin" />
          <div className="flex-1">
            <div className="flex items-center justify-between mb-1">
              <span className="text-sm font-medium text-primary">
                Preparing data for offline use...
              </span>
              <span className="text-xs text-primary">
                {progress}%
              </span>
            </div>
            <Progress value={progress} className="h-1" />
          </div>
        </div>
      </div>
    </div>
  );
}
